import { useMemo } from "react";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { ChartState } from "./ChartState";
import { formatAxis } from "./utils";
import { useTimeseries } from "@shared/hooks/useTimeseries";

export function KillsPerMatch({ from, useDaily, refreshKey }: { from: number | undefined; useDaily: boolean; refreshKey: number }) {
  const { data, error } = useTimeseries({ metric: "kills", bucket: useDaily ? "day" : "match", from, refreshKey });

  const points = useMemo(() => data?.map((point) => ({ t: point.t, kills: point.v, merged: point.merged ?? 1 })) ?? [], [data]);

  if (data === null) return <ChartState>Loading chart...</ChartState>;
  if (data.length === 0) return <ChartState>{error ? `Could not load chart: ${error}` : "No tracked match data yet."}</ChartState>;

  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={points}>
        <CartesianGrid stroke="#30363d" strokeDasharray="3 3" />
        <XAxis dataKey="t" stroke="#8b949e" tick={{ fontSize: 11 }} tickFormatter={(v) => formatAxis(v, useDaily)} minTickGap={40} />
        <YAxis stroke="#8b949e" tick={{ fontSize: 11 }} width={40} />
        <Tooltip contentStyle={{ background: "#161b22", border: "1px solid #30363d" }} labelFormatter={(v) => formatAxis(v as number | string, useDaily)} />
        <Bar dataKey="kills" fill="#f97316" radius={[2, 2, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
